import { useEffect } from 'react';
import {
  Route,
  Routes,
  useMatch,
  useNavigate,
  useParams,
} from 'react-router-dom';

import { routes, useShopAccessGuard } from '@frontend/utils';
import { PageNotFoundView } from '@frontend/views';

import { OrdersView } from './orders.view';

export const OrderRoutes = () => {
  const access = useShopAccessGuard();
  const { shopId } = useParams();
  const navigate = useNavigate();
  // Orders is also mounted at the bare `/:shopId`, which should land on `/:shopId/orders`.
  const isAtRoot = useMatch('/:shopId');

  // biome-ignore lint/correctness/useExhaustiveDependencies: redirect once access is known for the shop, not on every navigation
  useEffect(() => {
    if (access === 'allowed' && isAtRoot) {
      navigate(routes.orders(shopId), { replace: true });
    }
  }, [shopId, access]);

  if (access === 'denied') {
    return null;
  }

  return (
    <Routes>
      <Route path="/" element={<OrdersView />} />
      <Route path="/not-found" element={<PageNotFoundView />} />
    </Routes>
  );
};
